// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon--EoxbF{width:6em;height:6em}", "",{"version":3,"sources":["webpack://./src/gui/Components/Icons/TopRated/index.module.scss"],"names":[],"mappings":"AAAA,aAAM,SAAS,CAAC,UAAU","sourcesContent":[".icon{width:6em;height:6em}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "icon--EoxbF"
};
export default ___CSS_LOADER_EXPORT___;
